<phdsoft-window [options]="optionsWindow">
  <content content>
    <i *ngIf="loading" class="loading fa fa-spinner fa-pulse fa-5x fa-fw"></i>

    <!-- <button mat-mini-fab color="warn" [mat-dialog-close]="'{}'" class="closeBtn">
        <mat-icon>close</mat-icon>
      </button> -->

    <img *ngIf="!loading && image" [src]="urlSafe" />

    <embed *ngIf="!loading && embed" allow="autoplay; encrypted-media;" [type]="typeFile" [width]="embedWidth"
      height="95%" [src]="urlSafe" />

    <video controls autoplay *ngIf="!loading && video" width="100%" height="95%" [src]="urlSafe">
      Sorry, your browser doesn't support embedded videos.
    </video>

    <iframe *ngIf="!loading && iframe" id="idIframe" [src]="urlSafe" max-width="100%" max-height="95%" allowfullscreen
      allow="autoplay; encrypted-media">
    </iframe>
  </content>
  <ng-container footer>
    <button mat-icon-button type="button" (click)="questionDeleteDocument()">
      <mat-icon color="warn" class="mat-18">delete</mat-icon>
    </button>
  </ng-container>
  <!-- <div footer>
    <div fxLayout="row" fxLayoutAlign="between center" fxLayoutGap="10">
      <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="10">
        <button mat-icon-button type="submit" [mat-dialog-close]>
          <mat-icon color="primary" class="mat-18">check</mat-icon>
        </button>
        <button mat-icon-button mat-dialog-close>
          <mat-icon color="warn" class="mat-18">close</mat-icon>
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10">
        <button mat-icon-button mat-dialog-close>
          <mat-icon color="warn" class="mat-18">delete</mat-icon>
        </button>
      </div>
    </div>
  </div> -->
</phdsoft-window>